import axios from "axios"
import { API_URL, OWS_BASE_URL } from "../configs/app"


export const fetchHotels = async () => {
    let response = await axios.get(`${API_URL}/hotels`)
    return response.data
}
export const fetchSingleHotelBySlug = async ({queryKey}) => {
    let response = await axios.get(`${API_URL}/hotels/single-slug/${queryKey[1]}`)
    return response.data
}
export const fetchSingleHotelById = async ({queryKey}) => {
    let response = await axios.get(`${API_URL}/hotels/single-id/${queryKey[1]}`)
    return response.data
}

export const fetchRoomsByHotel = async ({queryKey}) => {
    let response = await axios.get(`${API_URL}/rooms/${queryKey[1]}`)
    return response.data
}
export const fetchAvailableRoomsByHotel = async ({queryKey}) => {
    const URL = `${OWS_BASE_URL}/availablity?arrival=${queryKey[1].arrival}&departure=${queryKey[1].departure}&property=${queryKey[1].property}&guestcount=${queryKey[1].adult}`
    let response = await axios.get(URL)
    console.log(response.data)
    return response.data
}

export const fetchSingleRoom = async ({queryKey}) => {
    let response = await axios.get(`${API_URL}/rooms/single/${queryKey[1]}`)
    return response.data
}

export const fetchBlockedDates = async ({ queryKey }) => {
    const response = await axios.get(`${API_URL}/blocked-dates?hotelSlug=${queryKey[1]}`)
    return response.data
}

export const checkBlockedDates = async ({queryKey}) => {
    const response = await axios.get(`${API_URL}/blocked-dates/check?hotelSlug=${queryKey[1].hotelSlug}&arrival=${queryKey[1].arrival}&departure=${queryKey[1].departure}`)
    return response.data
}

export const fetchHotelsAdmin = async () => {
    let response = await axios.get(`${API_URL}/hotels/admin/all`)
    return response.data
}

export const toggleHotelActive = async (data) => {
    let response = await axios.post(`${API_URL}/hotels/toggle-active`, data)
    return response.data
}

export const fetchRoomsByHotelAdmin = async ({queryKey}) => {
    let response = await axios.get(`${API_URL}/rooms/admin/all-by-hotel/${queryKey[1]}`)
    return response.data
}

export const toggleRoomActive = async (data) => {
    let response = await axios.post(`${API_URL}/rooms/toggle-active`, data)
    return response.data
}